import axios from 'axios'
const errorsHandler = require('@/services/errors')

const moduleName = 'matches'

const state = {}
const getters = {}

const getHeaders = context => ({
    Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`,
})

const actions = {
    adminOpen: async (context, payload = {}) => {
        const url = `api/v1/${moduleName}/admin/open`

        return axios
            .get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                headers: getHeaders(context),
                params: payload,
                'Content-Type': 'application/json',
            })
            .then(result => result.data.result)
            .catch(error => errorsHandler.errorHandler(error))
    },

    adminUpdate: async (context, payload) => {
        const url = `api/v1/${moduleName}/admin/${payload.id}`

        return axios
            .post(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                payload.item,
                {
                    headers: getHeaders(context),
                    'Content-Type': 'application/json',
                }
            )
            .then(result => ({
                success: true,
                result: result.data.result,
            }))
            .catch(error => errorsHandler.errorHandler(error))
    },

    adminUpdatePlayer: async (context, payload) => {
        const url = `api/v1/${moduleName}/admin/${payload.matchId}/players/${payload.playerId}`

        return axios
            .post(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                payload.item,
                {
                    headers: getHeaders(context),
                    'Content-Type': 'application/json',
                }
            )
            .then(result => ({
                success: true,
                result: result.data.result,
            }))
            .catch(error => errorsHandler.errorHandler(error))
    },

    adminAddGuest: async (context, payload) => {
        const url = `api/v1/${moduleName}/admin/${payload.matchId}/players/add-guest`

        return axios
            .post(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                payload.item,
                {
                    headers: getHeaders(context),
                    'Content-Type': 'application/json',
                }
            )
            .then(result => ({
                success: true,
                result: result.data.result,
            }))
            .catch(error => errorsHandler.errorHandler(error))
    },
}

const mutations = {}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
}
